module.exports = __webpack_public_path__ + "img/chofu_tourist_on.358c3e65.svg";